"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var getFavoriteCategorySuggestions_1 = require("../actions/helpers/getFavoriteCategorySuggestions");
var getFavoriteFolderSuggestions_1 = require("../actions/helpers/getFavoriteFolderSuggestions");
var getFavoritePeopleSuggestions_1 = require("../actions/helpers/getFavoritePeopleSuggestions");
var getFavoriteSearchSuggestions_1 = require("../actions/helpers/getFavoriteSearchSuggestions");
var datapoints_1 = require("../datapoints");
var mobx_react_1 = require("mobx-react");
var Icon_1 = require("office-ui-fabric-react/lib/Icon");
var Persona_1 = require("office-ui-fabric-react/lib/Persona");
var SearchBox_1 = require("office-ui-fabric-react/lib/SearchBox");
var owa_analytics_1 = require("owa-analytics");
var addFavoriteCategory_1 = require("owa-mail-favorites-store/lib/actions/addFavoriteCategory");
var addFavoriteFolder_1 = require("owa-mail-favorites-store/lib/actions/addFavoriteFolder");
var addFavoriteSearch_1 = require("owa-mail-favorites-store/lib/actions/addFavoriteSearch");
var addFavoritePersona_1 = require("owa-mail-favorites-store/lib/actions/people/addFavoritePersona");
var owa_mail_feature_flags_1 = require("owa-mail-feature-flags");
var owa_mail_find_favorites_store_1 = require("owa-mail-find-favorites-store");
var owa_mail_focus_manager_1 = require("owa-mail-focus-manager");
var owa_mail_folder_forest_actions_1 = require("owa-mail-folder-forest-actions");
var PersonaControl_1 = require("owa-persona/lib/components/PersonaControl");
var owa_mail_strings_1 = require("owa-strings/owa-mail-strings");
var React = require("react");
var styles = require('./FindFavorites.scss');
var classNames = require('classnames/bind');
var FindFavorites = /** @class */ (function (_super) {
    tslib_1.__extends(FindFavorites, _super);
    function FindFavorites() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.setFocusInSearchBox = function () {
            window.requestAnimationFrame(function () {
                if (_this.searchBox) {
                    _this.searchBox.focus();
                }
            });
        };
        _this.getFavoriteSuggestions = function (findText) {
            var favoriteFolderSuggestions = getFavoriteFolderSuggestions_1.default(findText);
            var favoritePeopleSuggestions = getFavoritePeopleSuggestions_1.default(findText);
            var favoriteSearchSuggestions = owa_mail_feature_flags_1.isMailFeatureEnabled('tri-favoriteSearch')
                ? getFavoriteSearchSuggestions_1.default(findText)
                : [];
            var favoriteCategorySuggestions = owa_mail_feature_flags_1.isMailFeatureEnabled('tri-categories')
                ? getFavoriteCategorySuggestions_1.default(findText)
                : [];
            var favoriteSuggestions = favoritePeopleSuggestions.concat(favoriteFolderSuggestions, favoriteSearchSuggestions, favoriteCategorySuggestions);
            owa_analytics_1.logUsage(datapoints_1.default.showFavoriteSuggestions.datapoint.name, datapoints_1.default.showFavoriteSuggestions.datapoint.customData(findText.length, favoritePeopleSuggestions.length, favoriteFolderSuggestions.length, favoriteSearchSuggestions.length, favoriteCategorySuggestions.length));
            return favoriteSuggestions;
        };
        _this.renderFavoriteSuggestion = function (id, type, data) {
            var suggestionType = type;
            switch (suggestionType) {
                case 0 /* Folder */:
                    return _this.renderFavoriteFolderSuggestion(id, data);
                case 1 /* Persona */:
                    return _this.renderFavoritePersonaSuggestion(id, data);
                case 2 /* Search */:
                    return _this.renderFavoriteSearchSuggestion(id, data);
                case 3 /* Category */:
                    return _this.renderFavoriteCategorySuggestion(id, data);
            }
            return null;
        };
        _this.onItemClicked = function (itemId, type, data) {
            var suggestionType = type;
            switch (suggestionType) {
                case 0 /* Folder */:
                    addFavoriteFolder_1.default(itemId, 'FavoritesPicker');
                    break;
                case 1 /* Persona */:
                    var personaType = data;
                    addFavoritePersona_1.default(personaType.EmailAddress.EmailAddress, personaType.EmailAddress.OriginalDisplayName, personaType.PersonaId.Id, 'FavoritesPicker');
                    break;
                case 2 /* Search */:
                    addFavoriteSearch_1.default(data, 'FavoritesPicker');
                    break;
                case 3 /* Category */:
                    addFavoriteCategory_1.default(itemId, 'FavoritesPicker');
                    break;
            }
            owa_mail_focus_manager_1.resetFocus();
            owa_analytics_1.logUsage(datapoints_1.default.addFavoriteFromPicker.datapoint.name, datapoints_1.default.addFavoriteFromPicker.datapoint.customData(owa_mail_find_favorites_store_1.findFavoritesStore.findText.length, suggestionType));
        };
        _this.renderSearchBox = function () {
            return (React.createElement(SearchBox_1.SearchBox, { ref: function (searchBox) { return (_this.searchBox = searchBox); }, key: 'ff_searchbox', className: classNames(styles.searchBox, styles.findFavoritesItemContainer), value: owa_mail_find_favorites_store_1.findFavoritesStore.findText, labelText: owa_mail_strings_1.default.searchForFavoriteText, onChange: function (newFindText) {
                    owa_mail_find_favorites_store_1.setFindText(newFindText);
                } }));
        };
        return _this;
    }
    FindFavorites.prototype.renderFavoriteCategorySuggestion = function (id, name) {
        return (React.createElement("div", { className: styles.suggestionWrapper },
            React.createElement(Icon_1.Icon, { className: styles.favIcon, iconName: "Color" /* Color */ }),
            React.createElement("span", { className: styles.suggestionDisplayName }, name)));
    };
    FindFavorites.prototype.renderFavoriteSearchSuggestion = function (id, data) {
        return (React.createElement("div", { className: styles.suggestionWrapper },
            React.createElement(Icon_1.Icon, { className: styles.favIcon, iconName: "Search" /* Search */ }),
            React.createElement("span", { className: styles.suggestionDisplayName }, data)));
    };
    FindFavorites.prototype.renderFavoritePersonaSuggestion = function (id, data) {
        var personaType = data;
        return (React.createElement("div", { className: styles.suggestionWrapper },
            React.createElement(PersonaControl_1.default, { className: styles.persona, name: personaType.EmailAddress.Name, emailAddress: personaType.EmailAddress.EmailAddress, size: Persona_1.PersonaSize.size24 }),
            React.createElement("span", { className: styles.suggestionDisplayName }, personaType.EmailAddress.Name)));
    };
    FindFavorites.prototype.renderFavoriteFolderSuggestion = function (id, data) {
        var folderIcon = owa_mail_folder_forest_actions_1.getCustomIcon(id, true /* showNonSpecialFolderIcon */);
        return (React.createElement("div", { className: styles.suggestionWrapper },
            React.createElement(Icon_1.Icon, { className: styles.favIcon, iconName: folderIcon }),
            React.createElement("span", { className: styles.suggestionDisplayName }, data)));
    };
    FindFavorites.prototype.render = function () {
        var _this = this;
        // Get items to show depending on the findText
        var itemsToShow = this.getFavoriteSuggestions(owa_mail_find_favorites_store_1.findFavoritesStore.findText);
        return (React.createElement("div", { key: 'findFavorites' },
            this.renderSearchBox(),
            itemsToShow.map(function (item) {
                return (React.createElement("div", { onClick: function (evt) {
                        _this.onItemClicked(item.id, item.type, item.data);
                    }, className: styles.findFavoritesItemContainer, "data-is-focusable": true, key: 'key' + item.id }, _this.renderFavoriteSuggestion(item.id, item.type, item.data)));
            })));
    };
    FindFavorites = tslib_1.__decorate([
        mobx_react_1.observer
    ], FindFavorites);
    return FindFavorites;
}(React.Component));
exports.default = FindFavorites;
//# sourceMappingURL=FindFavorites.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/owa-mail-find-favorites/lib/components/FindFavorites.js
// module id = 6275
// module chunks = 68